import IconBase from '@phosphor-icons/react/dist/lib/IconBase'
import type { IconProps, IconWeight } from '@phosphor-icons/react/dist/lib/types'
import { forwardRef, type ReactElement } from 'react'

// The upper half of Phosphor's CaretUpDown, so a sorted column shows exactly one triangle of the
// unsorted pair, in the same place. Phosphor's own CaretUp/CaretDown are wider and centred.
const weights = new Map<IconWeight, ReactElement>([
  [
    'bold',
    <path
      key="bold"
      d="M88.49,88.51L128,49l39.51,39.52a12,12,0,0,0,17-17l-48-48a12,12,0,0,0-17,0l-48,48a12,12,0,0,0,17,17Z"
    />
  ],
  [
    'fill',
    <path
      key="fill"
      d="M72.61,83.06a8,8,0,0,1,1.73-8.72l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,176,88H80A8,8,0,0,1,72.61,83.06Z"
    />
  ]
])

export const SortUp = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase ref={ref} {...props} weights={weights} />
))
SortUp.displayName = 'SortUp'
